<template>
  <!-- 更换下一阶段审批人modal -->
  <a-modal
    title="更换下一阶段审批人"
    :visible="visible"
    :confirm-loading="actionLoading"
    :mask-closable="false"
    @ok="handleOk"
    @cancel="handleCloseModal"
  >
    <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
      <a-form-item label="下一环节审批人">
        <span>
          {{
            `${nextApprovePerson.name} ${nextApprovePerson.username} ${nextApprovePerson.roleName}`
          }}
        </span>
      </a-form-item>
      <a-form-item label="变更审批人">
        <a-select
          v-decorator="$decorator('nextApprovePerson', '请选择下一环节审批人')"
          placeholder="请选择"
        >
          <a-select-option
            v-for="person in nextApprovePersons"
            :value="`${person.roleId}_${person.username}`"
            :key="`${person.roleId}_${person.username}`"
          >
            {{ `${person.name}, ${person.username}, ${person.roleName}` }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'NextApprovalModal',
  data() {
    return {
      form: this.$form.createForm(this, {
        name: 'nextApprovePersonForm',
      }),
    }
  },
  props: [
    'visible',
    'actionLoading',
    'nextApprovePerson',
    'nextApprovePersons',
  ],
  methods: {
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const { nextApprovePerson } = values
          const approvePerson = nextApprovePerson.split('_')
          const newNextApprovePerson = {
            roleId: approvePerson[0],
            username: approvePerson[1],
          }
          this.$emit('onSubmitModal', newNextApprovePerson)
          this.handleCloseModal()
        }
      })
    },
    handleCloseModal() {
      this.form.resetFields()
      this.$emit('onCloseModal')
    },
  },
}
</script>

<style></style>
